<template>
    <div class="row">
        <div class="card">
            <div class="card-header flex justify-between items-center">
                <h2>Lista de E-mails</h2>
            </div>
            <div class="card-body">
                <vue-good-table
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    ref="vue-good-table"
                    :columns="newsletters.columns"
                    :rows="newsletters.rows"
                    :totalRows="newsletters.total"
                    :responsive="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Resultados por página',
                        ofLabel: 'de',
                        pageLabel: 'página',
                        allLabel: 'Todos'
                    }"
                    styleClass="vgt-table striped"
                >
                    <div slot="emptystate">
                        <div class="text-center">
                            <p>Nenhum e-mail foi cadastrado.</p>
                        </div>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div
                            v-if="props.column.field === 'acoes'"
                            class="flex flex-col"
                        >
                            <div
                                class="h-6"
                                title="Excluir E-mail"
                                @click="deleteEmail(props.row)"
                            >
                                <svg-icon
                                    icon="delete"
                                    class="cursor-pointer text-primary"
                                >
                                </svg-icon>
                            </div>
                        </div>
                        <span>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";

export default {
    name: "listar-newsletter",

    components: {
        VueGoodTable
    },

    created() {
        this.getNewsLetter();
    },

    data() {
        return {
            newsletters: {
                columns: [
                    {
                        label: "E-mail",
                        field: "email"
                    },
                    {
                        label: "Ações",
                        field: "acoes",
                        filterable: false,
                        sortable: false,
                        width: "5%"
                    }
                ],
                rows: [],
                total: 0,
                filtros: {
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    page: 1,
                    perPage: 10
                }
            }
        };
    },

    methods: {
        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.filtrarNewsletters({ page: params.currentPage });
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarNewsletters({
                sort: {
                    type: params[0].type,
                    field: params[0].field
                }
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.filtrarNewsletters({ perPage: params.currentPerPage });
        },

        /**
         * Filtra as publicações conforme as mudanças
         * @param newProps
         */
        filtrarNewsletters(newProps) {
            this.newsletters.filtros = Object.assign(
                {},
                this.newsletters.filtros,
                newProps
            );
            this.getNewsLetter();
        },

        getNewsLetter() {
            this.axios("newsletter", {
                params: {
                    page: this.newsletters.filtros.page,
                    per_page: this.newsletters.filtros.perPage,
                    sortField: this.newsletters.filtros.sort.field,
                    sortType: this.newsletters.filtros.sort.type
                }
            }).then(response => {
                this.newsletters.rows = response.data.newsletter.data;
                this.newsletters.total = response.data.newsletter.total;
            });
        },

        deleteEmail(row) {
            this.$swal({
                title: "Excluir E-mail",
                text: "Você deseja excluir este e-mail?",
                icon: "question",
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonColor: "#6C9E1D",
                cancelButtonColor: "#E50053",
                cancelButtonText: "Não",
                confirmButtonText: "Sim"
            }).then(result => {
                if (result.value) {
                    this.axios
                        .delete(`/newsletter/${row.id}`)
                        .then(response => {
                            this.$swal({
                                title: "Sucesso",
                                text: "O e-mail foi excluido com sucesso!",
                                icon: "success"
                            });
                            this.newsletters.rows.splice(row.originalIndex, 1);
                        })
                        .catch(error => {
                            this.$swal({
                                title: "Algo de errado ocorreu",
                                text: error.response.data.message,
                                icon: "error"
                            });
                        });
                }
            });
        }
    }
};
</script>
